import { numberFormat } from "@/helper/format-data";
import clsx from "clsx";
import React from "react";
import { ArrowLeftIcon } from "@/components/icons/arrow-left-icon";

interface TrendProps {
  value: number;
  variant?: "filled" | "ghost";
}

const iconByTrend = {
  up: <ArrowLeftIcon className="transform -rotate-90" />,
  down: <ArrowLeftIcon className="transform rotate-90" />,
  sideways: <ArrowLeftIcon />,
};

const classByTrend = {
  up: "text-trend-positive",
  down: "text-trend-negative",
  sideways: "text-icon-secondary-dark",
};

const classByVariant = {
  ghost: {
    up: "",
    down: "",
    sideways: "",
  },
  filled: {
    up: "bg-trend-positive",
    down: "bg-trend-negative",
    sideways: "bg-icon-secondary",
  },
};

export const Trend: React.FC<TrendProps> = ({ value, variant = "ghost" }) => {
  const trend = value > 0 ? "up" : value < 0 ? "down" : "sideways";
  return (
    <div
      className={clsx(
        classByTrend[trend],
        "flex items-center gap-1 rounded-[30px] px-1 text-[9px]",
        classByVariant[variant][trend],
      )}
    >
      {iconByTrend[trend]}
      <span className="text-[9px] font-extrabold">{numberFormat(value, 0) || "0"}%</span>
    </div>
  );
};
